import { render, staticRenderFns } from "./SponsoredRecommendationMultiTitleNewPage.vue?vue&type=template&id=f204c42c&scoped=true"
import script from "./SponsoredRecommendationMultiTitleNewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationMultiTitleNewPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationMultiTitleNewPage.vue?vue&type=style&index=0&id=f204c42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204c42c",
  null
  
)

export default component.exports